<div class="pt-3" *ngIf="loadingAccount">
  <h2>Loading Account Info...</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 mb-6" *ngIf="!loadingAccount && (serverError === null)">
  <div class="floating-alert-container">
    <div class="alert alert-dismissible"
         [class.alert-success]="callbackResult.status === CallbackResultStatus.success"
         [class.alert-danger]="callbackResult.status === CallbackResultStatus.error"
         role="alert" *ngIf="callbackResult !== null">
      {{ callbackResult.text }}
      <button type="button" class="close" (click)="callbackResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <h2 class="mb-4">Account Settings</h2>

  <div class="row" *ngIf="!apiService.inPinMode">

    <div class="col-sm-5">
      <h3>Basic Info</h3>

      <form (ngSubmit)="updateBasicInfo()">

        <div class="form-group">
          <label for="firstNameInput">First Name</label>
          <input id="firstNameInput" type="text"
                 class="form-control" name="firstName"
                 [(ngModel)]="myAccount.first_name">
          <div class="form-text text-danger">{{ accountBasicInfoErrors.first_name }}</div>
        </div>

        <div class="form-group">
          <label for="lastNameInput">Last Name</label>
          <input id="lastNameInput" type="text"
                 class="form-control" name="lastName"
                 [(ngModel)]="myAccount.last_name">
          <div class="form-text text-danger">{{ accountBasicInfoErrors.last_name }}</div>
        </div>

        <div class="form-group" *ngIf="locationService.getLocations() === null">
          <label for="defaultGymInputLoading">Default Location</label>
          <select id="defaultGymInputLoading" class="custom-select" disabled>
            <option>Loading...</option>
          </select>
        </div>
        <div class="form-group" *ngIf="locationService.getLocations() !== null">
          <label for="defaultGymInput">Default Location</label>
          <select id="defaultGymInput" class="custom-select" name="defaultGym"
                  [(ngModel)]="myAccount.default_gym_id">
            <option *ngFor="let location of locationService.getLocations()"
                    [ngValue]="location.id">
              {{ location.name }}
            </option>
          </select>
          <div class="form-text text-danger">{{ accountBasicInfoErrors.default_gym_id }}</div>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="accountBasicInfoErrors.non_field_errors">
          {{ accountBasicInfoErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="accountBasicInfoErrorMessage">
          {{ accountBasicInfoErrorMessage }}
        </div>

        <div class="alert alert-info" role="alert" *ngIf="loadingAccountBasicInfo">
          Loading...
        </div>

        <div class="alert alert-success" role="alert" *ngIf="accountBasicInfoSuccessMessage">
          {{ accountBasicInfoSuccessMessage }}
        </div>

        <button type="submit" class="btn btn-primary mb-3 float-right">
          Save
        </button>
        <button type="button" class="btn btn-secondary mb-3" (click)="loadAccount()">
          Cancel
        </button>

      </form>
    </div>

    <div class="col-sm-6 offset-sm-1 mt-sm-0 mt-4">

      <h3>
        PIN Mode:
        <span class="text-danger">Disabled</span>
      </h3>

      <p>
        In order to activate PIN Mode, log out and select the "Require PINs when making changes" option when logging back in.
      </p>

      <hr>

      <h3>Change Password</h3>

      <form (ngSubmit)="updatePassword()">

        <div class="form-group">
          <label for="oldPasswordInput">Previous Password</label>
          <input id="oldPasswordInput" type="password"
                 class="form-control" name="oldPassword"
                 [(ngModel)]="previousPassword">
          <div class="form-text text-danger">{{ accountPasswordErrors.previous_password }}</div>
        </div>

        <div class="form-group">
          <label for="newPasswordInput">New Password</label>
          <input id="newPasswordInput" type="password"
                 class="form-control" name="newPassword"
                 [(ngModel)]="newPassword">
          <div class="form-text text-danger">{{ accountPasswordErrors.new_password }}</div>
        </div>

        <div class="form-group">
          <label for="newPasswordRepeatInput">Repeat New Password</label>
          <input id="newPasswordRepeatInput" type="password"
                 class="form-control" name="newPasswordRepeat"
                 [(ngModel)]="newPasswordConfirm">
          <div class="form-text text-danger">{{ accountPasswordErrors.new_password_confirm }}</div>
        </div>

        <div class="alert alert-danger" role="alert" *ngIf="accountPasswordErrors.non_field_errors">
          {{ accountPasswordErrors.non_field_errors }}
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="accountPasswordErrorMessage">
          {{ accountPasswordErrorMessage }}
        </div>

        <div class="alert alert-info" role="alert" *ngIf="loadingAccountPassword">
          Loading...
        </div>

        <div class="alert alert-success" role="alert" *ngIf="accountPasswordSuccessMessage">
          {{ accountPasswordSuccessMessage }}
        </div>

        <button type="submit" class="btn btn-primary mb-3 float-right">
          Change Password
        </button>
        <button type="button" class="btn btn-secondary mb-3" (click)="resetPasswordInput()">
          Cancel
        </button>

      </form>

      <hr>

      <h3>
        Two-Factor Authentication:
        <span class="text-success" *ngIf="myAccount.otp_enabled">Enabled</span>
        <span class="text-danger" *ngIf="!myAccount.otp_enabled">Disabled</span>
      </h3>

      <button type="button" class="btn btn-primary"
              *ngIf="!myAccount.otp_enabled"
              (click)="openSetUpTwoFactorAuthModal()">
        Set Up 2FA
      </button>
      <button type="button" class="btn btn-danger"
              *ngIf="myAccount.otp_enabled"
              (click)="openDisableTwoFactorAuthModal()"
              [disabled]="loadingDisableTwoFactorAuth"
              [class.disabled]="loadingDisableTwoFactorAuth">
        {{ loadingDisableTwoFactorAuth ? 'Loading...' : 'Disable 2FA' }}
      </button>

    </div>

  </div>

  <div *ngIf="apiService.inPinMode">
    <h3>
      PIN Mode:
      <span class="text-success">Enabled</span>
    </h3>

    <p>
      You may not edit your account settings while PIN Mode is active. In order to deactivate PIN Mode, log out and ensure the "Require PINs when making changes" option is not selected when logging back in.
    </p>

    <hr>

    <h3>
      Two-Factor Authentication:
      <span class="text-success" *ngIf="myAccount.otp_enabled">Enabled</span>
      <span class="text-failure" *ngIf="!myAccount.otp_enabled">Disabled</span>
    </h3>
  </div>
</div>
